import axios from 'axios';
import {
  GiftCardEligibilityGetResponse,
  RedeemGiftCardPostRequest,
  RedeemGiftCardPostResponse
} from 'types';

const API_URL =  `${process.env.PUBLIC_URL}/api`;

const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Request middleware
axiosInstance.interceptors.request.use((config) => {
  // Add something to each request
  return config;
}, (error) => {
    // Do something for each request error.
  return Promise.reject(error);
});

// Targeting criteria response middleware
axiosInstance.interceptors.response.use((response) => {
  // Do something after each successful response
  return response;
}, (error) => {
  // Do something for each api error.
  // e.g. redirect 401 responses to login page
  return Promise.reject(error);
});

const request = (config = {}) => axiosInstance(config);

export default {
  getUserEligibility: async () => {
    return request({
      method: 'get',
      url: '/user/eligibility',
    })
    .then(({ data }) => {
      return {
        ...(data as GiftCardEligibilityGetResponse),
        isAuthenticated: true
      };
    })
    .catch((err: any) => {
      const isAuthenticated = (err && err.response && err.response.status === 200);
      return {
        isAuthenticated: isAuthenticated,
        isEligible: false,
        errorMessage: err.toString()
      }
    });
  },
  postRedeemGiftCard: async (values: RedeemGiftCardPostRequest) => {
    return request({
      method: 'post',
      url: '/user/redeem',
      data: values
    })
    .then(({ data }) => data as RedeemGiftCardPostResponse)
    .catch((err: any) => {
      return err.response.data
    });
  }
};
